import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { settingOptions } from "./SettingData";

function SettingDialog({ setOpenDialog }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedValues, setSelectedValues] = useState([]);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedValues((prevValues) => [...prevValues, value]);
    } else {
      setSelectedValues((prevValues) => prevValues.filter((v) => v !== value));
    }
  };

  const handleAddNow = () => {
    handleClose();
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={handleClickOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Grid>
            {/* ---Close Button--- */}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
              className="iconBtnStyle"
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          {/* ---Heading--- */}
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="marginTop25 settingDialogMain"
          >
            <Grid item>
              <Typography className="font36 fontMedium colorBlue">
                Add <span className="colorYellow">Services</span>
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        {/* ---Body--- */}
        <DialogContent className="">
          <DialogContentText>
            {/* ---Body1--- */}
            <FormGroup>
              {settingOptions.map((option) => (
                <FormControlLabel
                  key={option.id}
                  control={<Checkbox />}
                  label={option.label}
                  className="settingDialogLabel colorBlack"
                  value={option.label}
                  onChange={handleCheckboxChange}
                />
              ))}
            </FormGroup>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="textCenter"
          >
            <Grid item sm={6}>
              <Button onClick={handleClose} className="settingDialogCancelBtn">
                Cancel
              </Button>
            </Grid>
            <Grid item sm={6} className="settingAddBtnMain">
              <Button className="settingAddBtn" onClick={handleAddNow}>
                Add Now
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SettingDialog;
